<template>
	<transition name='fade'>
		<div v-if="isBusy">
			<Modal v-if="modal"/>
			<div :class="$style.busy">
				<div :class="$style.spinner">
					<!-- <img :src="spinner"/> -->
					<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
					<circle cx="50" cy="50" r="45"/>
					</svg>            
				</div>
			</div>  
		</div>
	</transition>
</template>

<script>

// import spinner from './spinner.gif';
import Modal from "@/components/Modal/Modal.vue";

export function BusyState() {
	var busy_state = 0;

	this.isBusy = false;
				
	this.busy = function(call){
		busy_state++;
		this.isBusy = true;
		if(call){
			self.logs.push(call);
		}
	}

	this.notBusy = function(){
		busy_state--;
		if(busy_state<=0){
			busy_state = 0;
			this.isBusy = false;
			self.logs = [];
		}
	}

	this.getState = function() {
		return this.isBusy;
	}

}

export default {
	name: 'BusySpinner',
	props: {
		modal: {
			type: Boolean,
			required: false,
			default: true
		},
		isBusy: {
			type: Boolean,
			required: true,
			default: false
		}
	},
	components: {
		Modal
	},
	created: function(){
		this.init();
	},
	data: function(){
		return {
			logs: [],
			timer: null,
			config: {
					delay: 0
			}
		};
	},
	methods: {
		init: function(){
		},
	}
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
	transition: opacity .1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}

svg {
	animation: 2s linear infinite svg-animation;
	max-width: 100px;
}

/* // SVG animation. */
@keyframes svg-animation {
	0% {
		transform: rotateZ(0deg);
	}
	100% {
		transform: rotateZ(360deg)
	}
}

/* // Circle styles. */
circle {
	animation: 1.4s ease-in-out infinite both circle-animation;
	display: block;
	fill: transparent;
	stroke: white;
	stroke-linecap: round;
	stroke-dasharray: 283;
	stroke-dashoffset: 280;
	stroke-width: 10px;
	transform-origin: 50% 50%;
}

/* // Circle animation. */
@keyframes circle-animation {
	0%,
	25% {
		stroke-dashoffset: 280;
		transform: rotate(0);
	}
	
	50%,
	75% {
		stroke-dashoffset: 75;
		transform: rotate(45deg);
	}
	
	100% {
		stroke-dashoffset: 280;
		transform: rotate(360deg);
	}
}
</style>

<style module>
.busy{
		position: fixed;
		top: 40%;
		transform: translateY(-50%);
		left: 0px;
		width: 100%;
}

.spinner{
		/* border: 1px solid grey; */
		width: 100px;
		height: 100px;
		border-radius: 3px;
		position: relative;
		left: 50%;
		transform: translateX(-50%);
		background-color: transparent;
}

.spinner img{
		width: 100%;
}
</style>